import React, { useState } from "react";
import BJLogo from '../../../Assets/Images/BJ.png';
import './AdminLogin.css'
import { useAuth } from '../../../contexts/AuthContext';

const AdminLogin = () => {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        // Basic validation
        if (!email || !password) {
            setError('Email and password are required.');
            return;
        }
        if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        try {
            await login(email, password);
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
            
            <div className="card shadow p-4 AdminLoginContainer">
                <div className="text-center mb-4">
                <img
                    src={BJLogo}
                    alt="Logo"
                    className="img-fluid"
                />
            </div>
                <form onSubmit={handleSubmit}>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                            Email address
                        </label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">
                            Password
                        </label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;